import { styled } from 'styled-components'

export const StyledPlanTileContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`
